// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4f71b404","70":"d2f049dc","138":"c3d0450e","239":"9656a587","253":"a37d4fa9","325":"5571e0e7","455":"8827fd80","517":"d402b50c","555":"187669d7","592":"d602681c","672":"5d760149","687":"40eba24f","816":"2332dff2","866":"585ac626","925":"b704a917","959":"5a93bfad"}[chunkId] + ".chunk.js";
};